import { t } from "./i18n";

type ApplicationInfo = {
  name: string;
  url: string;
  icon: IconName;
  description: string;
};

export const applications = {
  dedale: {
    name: "Dedale",
    url: __env.DEDALE_URL,
    icon: "file_document",
    description: t("org_app.dedale.description"),
  },
} satisfies Record<string, ApplicationInfo>;

export type ApplicationKey = keyof typeof applications;

export const parseApplicationKey = (appKey: string | undefined): ApplicationKey | undefined => {
  if (appKey === undefined) {
    return undefined;
  }

  // @ts-expect-error checking existence of key
  if (applications[appKey] != null) {
    return appKey as ApplicationKey;
  }

  return undefined;
};
